import { translateField } from "@cdv/jazz-i18n";
import { Button, Stack, Typography } from "@mui/material";
import { ReactElement } from "react";
import AppBar from "../ui/AppBar";
import { Resource } from "../utils";
import { AntsGameComponent } from "../AntsGameComponent/AntsGameComponent";

export default function Content(): ReactElement {
  return (
    <>
      <AntsGameComponent />
      {/* <Stack sx={{ justifyContent: "center", minHeight: "78vh", mt: "0 !important" }} spacing={2}>
        <Stack sx={{ alignItems: "center" }}>
          <img src="/assets/07_ilustr_mravenci-b.svg" style={{ height: 216 }} />
        </Stack>

        <Typography sx={{ textAlign: "center" }}>
          Hlídej si své pivo! <br /> Rozmačkej bandu
          <br /> mravenčích násosků,
          <br /> co si na něj dělá zálusk.
        </Typography>

        <Stack spacing={2}>
          <Button size="large" variant="contained">
            START
          </Button>
        </Stack>
      </Stack> */}
    </>
  );
}
